import * as Yup from "yup";

export const lateRPMValidationSchema = Yup.object({
  account: Yup.string().required("Account is required"),
});
